import append from "../dom/append"
import ready from "./ready"
import registry from "./registry"

export const make_promise = (url: string): Promise<void> =>
  new Promise(resolve => {
    const script = document.createElement("script")
    script.onload = () => resolve()
    script.src = url

    append("body", script)
  })

const promises: Record<string, Promise<void>> = {}

const cached_promise = (url: string): Promise<void> => {
  return promises[url] || (promises[url] = make_promise(url))
}

export default (name: string, url: string, func?: () => void): void => {
  if (!registry[name]) {
    registry[name] = () => cached_promise(url)
  }
  if (func) ready(name as keyof typeof registry, func)
}
